import Icon from '@/components/ui/AppIcon';

interface Material {
  id: number;
  name: string;
  maxThickness: string;
  applications: string[];
  icon: string;
}

const materials: Material[] = [
{
  id: 1,
  name: 'Mild Steel',
  maxThickness: 'Up to 1" (25mm)',
  icon: 'CubeIcon',
  applications: ['Structural Components', 'Brackets & Enclosures', 'General Fabrication']
},
{
  id: 2,
  name: 'Stainless Steel',
  maxThickness: 'Up to 0.5" (12mm)',
  icon: 'SparklesIcon',
  applications: ['Food Processing Equipment', 'Medical Devices', 'Corrosion-Resistant Parts']
},
{
  id: 3,
  name: 'Aluminum',
  maxThickness: 'Up to 0.75" (19mm)',
  icon: 'BoltIcon',
  applications: ['Aerospace Components', 'Electronics Enclosures', 'Lightweight Structures']
},
{
  id: 4,
  name: 'Copper & Brass',
  maxThickness: 'Up to 0.375" (9mm)',
  icon: 'FireIcon',
  applications: ['Electrical Components', 'Heat Exchangers', 'Decorative Elements']
}];


export default function MaterialCompatibility() {
  return (
    <section className="lg:py-24 bg-card py-[70px]">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center space-x-2 bg-secondary/10 px-4 py-2 rounded-full mb-4">
            <Icon name="SwatchIcon" size={20} variant="solid" className="text-secondary" />
            <span className="text-sm font-cta font-semibold text-secondary">Material Expertise</span>
          </div>
          
          <h2 className="text-3xl lg:text-5xl font-headline font-bold text-foreground mb-6">
            Comprehensive Material Compatibility
          </h2>
          
          <p className="text-lg text-muted-foreground leading-relaxed">
            Our fabrication capabilities span a wide range of materials, each optimized for specific applications and performance requirements.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {materials.map((material) =>
          <div
            key={material.id}
            className="bg-background rounded-lg border border-border p-6 hover:border-primary transition-all duration-base">

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name={material.icon as any} size={24} variant="outline" className="text-primary" />
                </div>
                
                <div className="flex-1">
                  <h3 className="text-xl font-headline font-bold text-foreground mb-2">
                    {material.name}
                  </h3>
                  
                  <div className="flex items-center space-x-2 mb-4">
                    <Icon name="ArrowsPointingOutIcon" size={16} variant="outline" className="text-muted-foreground" />
                    <span className="text-sm font-semibold text-accent">{material.maxThickness}</span>
                  </div>
                  
                  <div className="space-y-2">
                    {material.applications.map((app, index) =>
                  <div key={index} className="flex items-start space-x-2">
                        <Icon name="CheckIcon" size={16} variant="outline" className="text-success flex-shrink-0 mt-0.5" />
                        <span className="text-sm text-muted-foreground">{app}</span>
                      </div>
                  )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      
      
      </div>
    </section>);

}